"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomIndex = exports.getElements = exports.closest = exports.formatNumber = exports.transformOptions = exports.getClassNames = exports.createObjUniqueKey = exports.createUniqueKey = void 0;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var createUniqueKey = function createUniqueKey(index, label) {
  return index + encodeURIComponent(label);
};

exports.createUniqueKey = createUniqueKey;

var createObjUniqueKey = function createObjUniqueKey(data) {
  return Object.values(data).map(function (i) {
    return _typeof(i) === 'object' ? Object.values(i).join() : i;
  }).join();
};

exports.createObjUniqueKey = createObjUniqueKey;

var getClassNames = function getClassNames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.map(function (arg) {
    return arg && _typeof(arg) === 'object' ? Object.keys(arg).filter(function (item) {
      return arg[item];
    }) : arg;
  }).reduce(function (acc, val) {
    return acc.concat(val);
  }, []).filter(function (item) {
    return item;
  }).join(' ');
};

exports.getClassNames = getClassNames;

var transformOptions = function transformOptions(options) {
  return options.map(function (option) {
    return typeof option === 'string' ? {
      label: option,
      value: option
    } : option;
  });
};

exports.transformOptions = transformOptions;

var formatNumber = function formatNumber(n) {
  return n.replace(/\D/g, '');
};

exports.formatNumber = formatNumber;

var matches = function matches(element, selector) {
  if (element.matches) return element.matches(selector);
  return element.msMatchesSelector(selector);
};

var closest = function closest(el, selector, rootNode) {
  var element = el;

  while (element) {
    var isRoot = element === rootNode || element === document.body;

    if (isRoot || element.nodeType === 1 && matches(element, selector)) {
      if (isRoot) {
        element = null;
      }

      break;
    }

    element = element.parentNode;
  }

  return element;
};

exports.closest = closest;

var getElements = function getElements(index, selector, rootNode) {
  return rootNode.querySelectorAll("".concat(selector, ":nth-child(").concat(index + 1, ")"));
};

exports.getElements = getElements;

var getDomIndex = function getDomIndex(el) {
  return Array.from(el.parentNode.children).indexOf(el);
};

exports.getDomIndex = getDomIndex;